import axios from 'axios'
import { Loading, Message } from 'element-ui'
// import router from '../router'
let loading
function startLoading () {
  loading = Loading.service({
    lock: true,
    body: true,
    text: '加载中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

function endLoading () {
  loading.close()
}
// 请求拦截
axios.interceptors.request.use(config => {
  // 加载动画
  if (!config.loadingClose) {
    startLoading()
  }

  // 设置地址
  const host = process.env.NODE_ENV === 'development' ? '' : 'https://weixin.qiyehuo.com'
  // const host = process.env.NODE_ENV === 'development' ? '' : 'https://weixin.qiyehuo.com'
  config.baseURL = host
  // http://192.168.0.115
  if (localStorage.authShowToken) {
    // 设置统一的请求header
    config.headers.authShowToken = localStorage.authShowToken
  }

  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截
axios.interceptors.response.use(response => {
  // 结束动画
  if (!response.config.loadingClose) {
    endLoading()
  }

  if (response.data.code === 401) {
    localStorage.removeItem('authShowToken')
    Message.info('登录信息已过期,企业火系统已为您自动登录!')
    window.open('https://weixin.qiyehuo.com/api/third_work_weixin_redirect_uri','_self')
  }

  return response
}, error => {
  // 结束动画
//   endLoading()

  // 获取状态码
//   const { status } = error.response
//   if (status === 403 || status === 402) {
    // 清除token
    // localStorage.removeItem('token')
    // 跳转到登录页
    // router.push('/login')
//   }
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/authShowConfig/axios.js